<ng-container *transloco="let g; read: 'payment.status'">
  <!-- t(PROCESSING,FAILED,NOT_STARTED,SUCCEEDED) -->
  <ng-container *ngIf="withTitle; else justStatus">
    {{g('title')}} {{g(status)}}
  </ng-container>
  <ng-template #justStatus>
    {{g(status) | titlecase}}
  </ng-template>
</ng-container>
